<template>
  <header class="header">
    <div class="content">
      <div class="header__row">
        <section class="header__logo">
          <a href="/"><img src="@/assets/img/svg/logo.svg" alt=""></a>
        </section>
        
        <AppUserPanel :isBoss="isBoss" />
      </div>
        
    </div>
      
  </header>
</template>

<script>
import AppUserPanel from '@/components/UserPanel.vue'

export default {
    name: 'AppHeader',
    props: ['isBoss'],
    components: {
      AppUserPanel,
    }
}
</script>

<style lang="scss" scoped>
  .header {
      display: flex;
      background: #004382;
      padding: 16px 0 13px;

      &__row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
      }
  }
</style>